import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/axiosAuth";

export const fetchOrdersPerBranchPeriodSummary = createAsyncThunk(
  "ordersBranchSourcePeriod/fetchOrdersPerBranchPeriodSummary",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/api/orders-per-branch-period-summary",
        requestData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "حدث خطأ أثناء جلب البيانات"
      );
    }
  }
);

const ordersBranchSourcePeriodSlice = createSlice({
  name: "ordersBranchSourcePeriod",
  initialState: {
    data: [],
    status: "idle",
    error: null,
    from_date: null,
    to_date: null,
    from_hour: null,
    to_hour: null,
  },
  reducers: {
    clearBranchPeriodData: (state) => {
      state.data = [];
      state.status = "idle";
      state.error = null;
      state.from_date = null;
      state.to_date = null;
      state.from_hour = null;
      state.to_hour = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrdersPerBranchPeriodSummary.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchOrdersPerBranchPeriodSummary.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.branches || [];
        state.from_date = action.payload.from_date;
        state.to_date = action.payload.to_date;
        state.from_hour = action.payload.from_hour;
        state.to_hour = action.payload.to_hour;
        state.error = null;
      })
      .addCase(fetchOrdersPerBranchPeriodSummary.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.data = [];
        state.from_date = null;
        state.to_date = null;
        state.from_hour = null;
        state.to_hour = null;
      });
  },
});

export const { clearBranchPeriodData } = ordersBranchSourcePeriodSlice.actions;
export default ordersBranchSourcePeriodSlice.reducer;
